module.exports = __webpack_public_path__ + "static/media/Photography.df69feee.svg";